import React from 'react';

const NotFound = () => {
  return (
    <>
      <div className='' style={{ margin: '8em auto' }}>
        <div className='container text-center'>
          <p className='display-4'>
            404 <br /> PAGE NOT FOUND
          </p>
        </div>
      </div>
    </>
  );
};

export default NotFound;
